<template>
  <div class="notifications-section mx-auto pt-4">
    <div class="d-flex justify-end">
      <v-overlay :value="overlay" class="d-flex" opacity="0.3">
        <v-card light max-width="450">
          <v-card-text>
            <div class="overline">{{ notificationDetail.title }}</div>
            <div class="subtitle-2">
              first read:
              {{
                notificationDetail.date_read
                  ? formatDate(notificationDetail.date_read)
                  : "now"
              }}
            </div>
            <v-divider></v-divider>
            <p class="body-1">
              {{ notificationDetail.body }}
            </p>
          </v-card-text>
          <v-card-actions>
            <v-btn text @click="overlay = false">
              close
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-overlay>
    </div>

    <v-sheet elevation="4" class="pa-4">
      <span class="subtitle-1">Notifications</span>
      <v-simple-table>
        <template v-slot:default>
          <tbody>
            <tr
              :class="notificationRowClasses(notification)"
              v-for="notification in notifications"
              :key="notification.id"
              @click="notificationDetails(notification)"
            >
              <td class="read-icon">
                <v-icon v-if="notification.read" class="read-row"
                  >mdi-email-open-outline</v-icon
                >
                <v-icon v-else class="unread-row">mdi-email-outline</v-icon>
              </td>
              <td>{{ notification.title }}</td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
    </v-sheet>
  </div>
</template>

<script>
import moment from "moment"

export default {
  props: {
    notifications: { type: Array, default: () => [] }
  },
  data: function() {
    return {
      overlay: false,
      notificationDetail: { title: "", body: "" }
    }
  },
  methods: {
    notificationDetails(notification) {
      this.notificationDetail = notification
      this.overlay = true
      this.$store.dispatch("notifications/markAsRead", notification.id)
    },
    formatDate(dateString) {
      if (dateString) {
        let givenDate = new Date(dateString)
        return moment(givenDate).format("MMM D")
      } else {
        return ""
      }
    },
    notificationRowClasses(notification) {
      return notification.read
        ? "clickable-row read-row"
        : "clickable-row unread-row"
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../scss/variables";

.read-icon {
  width: 20px;
}

.notifications-section {
  max-width: 650px;
}

.clickable-row {
  cursor: pointer;
}

.unread-row {
  color: $orange;
}

.read-row {
  color: $light-grey;
}
</style>
